import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import useDocumentTitle from "../../../components/helpers/useDocumentTitle";
import PageHeader from "../../../components/shared/PageHeader";
import PageMain from "../../../containers/shared/PageMain";
import apiClient from "../../../components/utils/apiClient";
import MainContent from "../../../containers/shared/MainContent";
import NormalFormContainer from "../../../containers/shared/NormalFormContainer";
import InputField from "../../../components/shared/InputField";
import ModalContainer from "../../../containers/shared/ModalContainer";
import NormalButton from "../../../components/shared/NormalButton";
import TextArea from "../../../components/shared/TextArea";
import SingleImageCompress from "../../../components/helpers/SingleImageCompress";
import Loading from "../../../components/shared/Loading";
import Toast from "../../../components/shared/Toast";
import MapAutocomplete from "../../../components/shared/MapAutocomplete";
import CityConverter from "../../../components/helpers/CityConverter";
import { UserContext } from "../../../App";
import MultiSelect from "../../../components/shared/MultiSelect";

const UnitAddPage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle('إنشاء وحدة جديدة');
    const { id } = useParams();
    const navigate = useNavigate();
    const pageTitle = {title: 'إنشاء وحدة جديدة', subTitle: 'يمكنك إنشاء وحدتك من هنا'};
    const [addUnitForm,setAddUnitForm] = useState({name: '', description: '', area: '', numOfRooms: '', addressDetails: {}, files: []});
    const [errors, setErrors] = useState(null);
    const [roleInfoModal, setRoleInfoModal] = useState(false);
    const [isAddUnitFormDisabled, setIsAddUnitFormDisabled] = useState(true);
    const [uploadPreview, setUploadPreview] = useState(null);
    const [compressedImage, setCompressedImage] = useState(null);
    const [showLoading, setShowLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(false);
    const [UnitId, setUnitId] = useState(null);
    const [toast, setToast] = useState({show: false,type: null, message:'' });
    const [addressDetails, setAddressDetails] = useState(null);
    const [showNotSupportedCity, setShowNotSupportedCity] = useState(false);
    const [property, setProperty] = useState(null);
    const [unitsCount, setUnitsCount] = useState(null);
    const [userData, setUserData] = useState(null);
    const [showExtraUnitConfirmModal, setShowExtraUnitConfirmModal] = useState(false);

    const {businessPackage} = useContext(UserContext);


    const getProperty = async () => {
        try {
            const response = await apiClient.get(`/b-properties/${id}`);
            if(response?.data) {
                setProperty(response?.data);
            } else {

            }
        } catch(err) {}
    }

    const getUnitsCount = async () => {
        try {
            const response = await apiClient.get(`/b-units/business-units-count`);
            if(response?.data) {
                setUnitsCount(response?.data?.unitsCount);
            } else {

            }
        } catch(err) {}
    }  

    useEffect(()=>{
        getProperty();
        getUnitsCount();
    },[])
  
    useEffect(()=>{
      if(addUnitForm && addUnitForm?.name && addUnitForm?.addressDetails && addressDetails?.location.latitude && addressDetails?.location.latitude !== ''
        && addressDetails?.location.longitude && addressDetails?.location.longitude !== ''
      ) {
        if((addUnitForm?.spendingLimit && addUnitForm?.spendingLimitFrequency) || (!addUnitForm?.spendingLimit && !addUnitForm?.spendingLimitFrequency)) {
            setIsAddUnitFormDisabled(false);
        } else {
            setIsAddUnitFormDisabled(true);
        }
      } else {
        setIsAddUnitFormDisabled(true);
      }
    },[addUnitForm,addressDetails]);
  
    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }


    const handleCloseModal = () => {
        setShowNotSupportedCity(false);
    }


    const handleCloseConfirmModal = () => {
        setShowExtraUnitConfirmModal(false);
    }


    function handleChangeUpload(e) {
        SingleImageCompress(e.target.files[0]).then(compressedFile=>setCompressedImage(compressedFile));
        setUploadPreview(URL.createObjectURL(e.target.files[0]));
    }


    const handleSubmitAddUnit = () => {
        if((businessPackage?.packageRestrictions?.additionalUnitCost && businessPackage?.packageRestrictions?.maxUnits && unitsCount && unitsCount >= businessPackage?.packageRestrictions?.maxUnits)) {
            setShowExtraUnitConfirmModal(true);
        } else {
            setShowLoading(true);
            setIsAddUnitFormDisabled(true);
            handleSubmitAddUnitAction();
        }
    }

    const handleSubmitAddUnitAction = async () => {
        setErrors(null);
        const finalAddUnitForm = addUnitForm;
        finalAddUnitForm.addressDetails = addressDetails;
        finalAddUnitForm.propertyId = id;
        if(finalAddUnitForm?.addressDetails?.city) {
            finalAddUnitForm.addressDetails.city = CityConverter(finalAddUnitForm?.addressDetails?.city,'ar');
        }
        finalAddUnitForm.addressDetails.addressLine = finalAddUnitForm?.address;
        finalAddUnitForm.description = 'وصف الوحدة';
        if((finalAddUnitForm?.addressDetails?.city && finalAddUnitForm?.addressDetails?.city !== 'notFound') || finalAddUnitForm?.addressDetails === null) {
            try {
                const response = await apiClient.post(`/b-units`,Object.fromEntries(Object.entries(finalAddUnitForm).filter(([_, v]) => v !== '')));
                if(response?.data) {
                    setShowLoading(false);
                    setUnitId(response?.data?._id);
                    setSuccessMessage(true);
                } else {
                    setIsAddUnitFormDisabled(false);
                    setShowLoading(false);
                }
                } catch(err) {
                    setIsAddUnitFormDisabled(false);
                    setShowLoading(false);
                    if(err?.response?.data?.errors) {
                        let errorsList = {};
                        err?.response?.data?.errors?.map(err=>{
                            errorsList[err.field] = err.message; 
                        });
                        setErrors(errorsList);
                    }
                }
        } else {
            setShowLoading(false);
            setShowNotSupportedCity(true);
            setIsAddUnitFormDisabled(false);
        }
    }
    

    const handleClickUnitDetails = () => {
        navigate(`/ar/unit/${UnitId}`);
    }

    const handleGetUser = (user) => {
        setUserData(user);
    }

    const spendingLimitFrequencyOptions = [
        {label:'يومي', value: 'daily'},
        {label:'شهري', value: 'monthly'},
        {label:'ربع سنوي', value: 'quarterly'},
        {label:'سنوي', value: 'yearly'},
    ]

    const handleClickConfirmExtraUnitAction = () => {
        setShowExtraUnitConfirmModal(false);
        setShowLoading(true);
        setIsAddUnitFormDisabled(true);
        handleSubmitAddUnitAction();
    }
      

    useEffect(()=>{
        if(!addUnitForm.spendingLimit) {
            setAddUnitForm({ ...addUnitForm, spendingLimitFrequency: ''});
        }
    },[addUnitForm.spendingLimit])

    const getUserRole = () => {
        if(userData?.role?.id) {
            return userData?.role?.id;
        } else {
            return userData?.role;
        }
    }

  return (
    <>
        <div>
        <PageHeader pageTitle={pageTitle} userCallback={handleGetUser} />
        <PageMain>
            <div className="fixed top-0 left-0 w-full h-full bg-grey-50 z-[-1]"></div>
            <MainContent>
                {(businessPackage?.packageRestrictions?.additionalUnitCost && businessPackage?.packageRestrictions?.maxUnits && unitsCount && unitsCount >= businessPackage?.packageRestrictions?.maxUnits) ? <div className="my-[16px] h-[46px] leading-[46px] bg-[#FFF9F0] text-[#D87E00] text-[16px] font-[600] rounded-[12px] px-[12px] cairo-font relative">
                    <img src="/assets/images/info-circle-info.svg" alt="" className="inline-block me-[8px]" />
                    تنبيه: لقد تعديت الحد المسموح في الباقة لاضافة وحدات ({businessPackage?.packageRestrictions?.maxUnits} وحدة) يمكنك اضافة وحدتك بمصاريف اضافية
                </div> : ''}
                <div className="flex flex-nowrap gap-x-[24px]">
                    <div className="w-[calc(100%-350px)]">
                        <NormalFormContainer full heading="من فضلك قم بملئ البيانات التالية لإنشاء وحدة جديدة." label="أضف وحدة جديدة">
                            
                            <div className="mb-[15px]">
                                <InputField isRequird label={`اسم ${property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'الوحدة'}`} placeholder={'اكتب الاسم'} value={addUnitForm?.name} error={errors?.name} errorMessage={errors?.name} translateError={true} onChange={(e)=>{setAddUnitForm({ ...addUnitForm, name: e.target.value }); hideError('name')}} />
                            </div>

                            <div className="mb-[15px]">
                                <InputField isRequird label={`عنوان ${property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'الوحدة'} الوطني`} placeholder={'اكتب الاسم'} value={addUnitForm?.address} error={errors?.address} errorMessage={errors?.address} translateError={true} onChange={(e)=>{setAddUnitForm({ ...addUnitForm, address: e.target.value }); hideError('address')}} />
                            </div>

                            {/* <div className="mb-[15px]">
                                <TextArea label={'وصف الوحدة'} placeholder={'مثال لنص يمكن استخدامة كوصف للوحدة'} value={addUnitForm?.description} error={errors?.description} errorMessage={errors?.description} translateError={true} onChange={(e)=>{ setAddUnitForm({ ...addUnitForm, description: e.target.value }); hideError('description')}} />
                            </div> */}

                            <div className="mb-[15px]">
                                <label className="mb-[5px] block">عنوان {property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'الوحدة'}<span className="text-danger">*</span></label>
                                <MapAutocomplete error={errors?.addressDetails} errorMessage={errors?.addressDetails} setAddressDetails={setAddressDetails} />
                            </div>

                            {/* <div className="flex mb-[15px] gap-x-[16px]">
                                <div className="relative w-[50%]">
                                    {addUnitForm?.area && addUnitForm?.area !== '' && <span className="font-[500] block text-grey-300 text-[16px] absolute top-[34px] end-[15px] z-[2]">متر مربع</span>}
                                    <InputField label={'المساحة الكلية التقريبية (اختياري)'} placeholder={'اكتب المساحة الكلية التقريبية للوحدة'} value={addUnitForm?.area} error={errors?.area} errorMessage={errors?.area} translateError={true} onChange={(e)=>{ if(e.target.value === '' || (/^[0-9\b]+$/.test(e.target.value) && e.target.value > 0 )) { setAddUnitForm({ ...addUnitForm, area: e.target.value ? parseInt(e.target.value) : '' }) }; hideError('area')}} />
                                </div>
                                <div className="w-[50%]">
                                    <InputField label={'عدد الغرف (اختياري)'} placeholder={'اكتب الغرف في الوحدة'} value={addUnitForm?.numOfRooms} error={errors?.numOfRooms} errorMessage={errors?.numOfRooms} translateError={true} onChange={(e)=>{ if(e.target.value === '' || (/^[0-9\b]+$/.test(e.target.value) && e.target.value > 0 )) { setAddUnitForm({ ...addUnitForm, numOfRooms: e.target.value ? parseInt(e.target.value) : '' }) }; hideError('numOfRooms')}} />
                                </div>
                            </div> */}

                            <div className="mb-[15px] relative">
                                <InputField disabled={!['OWNER','ADMINISTRATOR'].includes(getUserRole())} label={`حد مصاريف الصيانة`} placeholder={`اكتب الحد الذي تريد ان ننبهك عند تعديه لهذة الوحدة`}  error={errors?.spendingLimit} errorMessage={errors?.spendingLimit} value={addUnitForm?.spendingLimit ? addUnitForm?.spendingLimit : ''} onChange={(e)=>{setAddUnitForm({ ...addUnitForm, spendingLimit: parseFloat(e.target.value) }); hideError('spendingLimit')}} />
                                <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute end-[12px] top-[43px]">
                                    <g clipPath="url(#clip0_5628_42783)">
                                    <path d="M6.84841 10.6314C6.65212 11.0563 6.52237 11.5173 6.47266 12.0008L10.6266 11.1389C10.8229 10.7141 10.9525 10.253 11.0024 9.76953L6.84841 10.6314Z" fill="#475569"/>
                                    <path d="M10.6242 8.55594C10.8205 8.1312 10.9503 7.67007 11 7.18659L7.76421 7.85833V6.56701L10.6241 5.97378C10.8204 5.54904 10.9502 5.08791 10.9999 4.60443L7.76411 5.27559V0.631619C7.26829 0.90335 6.82796 1.26505 6.47001 1.6917V5.54417L5.17591 5.81265V0C4.68009 0.271635 4.23976 0.633434 3.88181 1.06008V6.08104L0.986256 6.68162C0.789964 7.10636 0.660114 7.56749 0.610307 8.05097L3.88181 7.37236V8.99854L0.375754 9.72577C0.179462 10.1505 0.0497091 10.6116 0 11.0951L3.66986 10.3339C3.96861 10.2732 4.22537 10.1008 4.39231 9.86359L5.06534 8.88966V8.88947C5.13521 8.7887 5.17591 8.66721 5.17591 8.53636V7.10388L6.47001 6.83539V9.41803L10.6241 8.55575L10.6242 8.55594Z" fill="#475569"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_5628_42783">
                                    <rect width="11" height="12" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </div>

                            <div className="mb-[15px]">
                                <MultiSelect isRequird={!!addUnitForm?.spendingLimit} isClearable disabled={userData?.role?.id !== 'OWNER'} label={'مدة إعادة ضبط حد مصاريف الصيانة'} placeholder={'اختر المدة'} options={spendingLimitFrequencyOptions} error={errors?.spendingLimitFrequency} errorMessage={errors?.spendingLimitFrequency} value={addUnitForm?.spendingLimitFrequency} onChange={(option)=>{setAddUnitForm({ ...addUnitForm, spendingLimitFrequency: option?.value ? option?.value : '' }); hideError('spendingLimitFrequency')}} />
                                <p className="font-[500] text-grey-600 mt-[8px] leading-[21px]">سيتم اعادة ضبط حد المصاريف حسب المدة المختارة من تاريخ اليوم</p>
                            </div>


                            <div className="mb-[15px]">
                                <InputField isRequird label={`اسم المسؤول عن ${property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'الوحدة'}`} placeholder={'اكتب الاسم بالكامل'} value={addUnitForm?.contactName} error={errors?.contactName} errorMessage={errors?.contactName} translateError={true} onChange={(e)=>{setAddUnitForm({ ...addUnitForm, contactName: e.target.value }); hideError('contactName')}} />
                            </div>

                            <div className="mb-[15px]">
                                <InputField isRequird phone={true} label={t("forms.mobileLabel")} value={addUnitForm?.contactPhone?.replace('+966','')} error={errors?.contactPhone} errorMessage={errors?.contactPhone} translateError={true} onChange={(e)=>{ if(e.target.value === '' || /^[0-9\b]+$/.test(e.target.value)) { setAddUnitForm({ ...addUnitForm, contactPhone: '+966'+e.target.value }) }; hideError('contactPhone')}} />
                            </div>

                            <div className="text-end">
                                 <NormalButton isDisabled={isAddUnitFormDisabled || ((businessPackage?.packageRestrictions?.additionalUnitCost && businessPackage?.packageRestrictions?.maxUnits && unitsCount && unitsCount >= businessPackage?.packageRestrictions?.maxUnits) && (businessPackage?.packageRestrictions?.additionalUnitCost > userData?.business?.credits))} label={`إنشاء ${property?.propertyType?.unitDisplayName ? property?.propertyType?.unitDisplayName : 'الوحدة'}`} onClick={handleSubmitAddUnit} />
                            </div>

                        </NormalFormContainer>
                    </div>
                    <div className="w-[325px] pt-[16px]">
                        {(businessPackage?.packageRestrictions?.additionalUnitCost && businessPackage?.packageRestrictions?.maxUnits && unitsCount && unitsCount >= businessPackage?.packageRestrictions?.maxUnits) ? <div className="w-[324px] mt-[25px] bg-white rounded-[8px] p-[16px]">
                            <div className="flex border-dashed border-b-[1px] border-b-grey-300 py-[15px]">
                                <div className="w-[75%]">
                                    <p className="text-grey-900 text-[16px] font-[500]">إضافة وحده جديدة</p>
                                </div>
                                <div className="w-[25%]">
                                    <p className="text-grey-900 text-[16px] font-[500] text-end">{businessPackage?.packageRestrictions?.additionalUnitCost} <img src="/assets/images/SAR-med.svg" alt="" className="w-[13px] align-middle inline-block select-none" /></p>
                                </div>
                            </div>
                            <div className="flex border-dashed border-b-[1px] border-b-grey-300 py-[15px]">
                                <div className="w-[75%]">
                                    <p className="text-grey-900 text-[16px] font-[500]">المجموع المبدئي</p>
                                </div>
                                <div className="w-[25%]">
                                    <p className="text-grey-900 text-[16px] font-[500] text-end">{businessPackage?.packageRestrictions?.additionalUnitCost} <img src="/assets/images/SAR-med.svg" alt="" className="w-[13px] align-middle inline-block select-none" /></p>
                                </div>
                            </div>
                            <div className="flex pt-[15px]">
                                <div className="w-[75%]">
                                    <p className="text-grey-900 text-[16px] font-[500]">إجمالي ما سيتم دفعه</p>
                                </div>
                                <div className="w-[25%]">
                                    <p className="text-grey-900 text-[18px] font-[700] text-end">{businessPackage?.packageRestrictions?.additionalUnitCost} <img src="/assets/images/SAR-med.svg" alt="" className="w-[15px] align-middle inline-block select-none" /></p>
                                </div>
                            </div>
                            {userData?.business?.credits >= businessPackage?.packageRestrictions?.additionalUnitCost
                            ? <div className="text-success text-[14px] text-center font-[500] leading-[21px] my-[15px]">
                            رصيد المحفظة كافي لإتمام الطلب
                            </div>
                            : <div className="flex flex-nowrap gap-x-[5px]">
                                <div className="w-[calc(100%-95px)] text-danger text-[14px] font-[500] leading-[21px] my-[15px]">
                                رصيد المحفظة غير كافي لإتمام الطلب
                                </div>
                                <div className="w-[90px] text-end pt-[10px]">
                                    <Link className="inline-block bg-blue text-white p-[4px_8px] text-[14px] rounded-[8px] text-center text-nowrap" to="/ar/wallet" target="_blank" rel="noopener noreferrer">شحن المحفظة</Link>
                                </div>
                            </div>}
                        </div> : ''}
                    </div>
                </div>
            </MainContent>
        </PageMain>
        </div>
        { successMessage && <ModalContainer hideX={true} maxWidth={'600px'} handleCloseModal={handleCloseModal}>
            <div className="text-center mb-[16px]">
                <span className="block w-[128px] h-[128px] m-auto !bg-center !bg-no-repeat" style={{background:"url('/assets/images/success.svg')"}} ></span>
            </div>
            <div className="text-center text-grey-900 mb-[80px]">
                <p className="font-[700] text-[30px] leading-[185%]">تهانينا !</p>
                <p className="font-[500] text-[24px] leading-[185%]">لقد قمت بإنشاء وحدتك بنجاح.</p>
            </div>
            <div className="text-center bg-grey-100 absolute bottom-0 left-0 w-full h-[96px] pt-[24px]">
                <NormalButton label={'الذهاب الى تفاصيل الوحدة'} onClick={handleClickUnitDetails} color={'!bg-grey-800'} />
            </div>
        </ModalContainer> }
        { showNotSupportedCity && <ModalContainer heading="حدث خطأ" handleCloseModal={handleCloseModal}>
            <div>
              عذرا, لقد اخترت مدينة خارج التغطية في الوقت الحالي.
            </div>
            <div className="text-end">
              <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none" onClick={handleCloseModal}>حسنا</div>
            </div>
        </ModalContainer> }
        {showExtraUnitConfirmModal && <ModalContainer heading="مصاريف إضافة وحدة إضافية" handleCloseModal={handleCloseConfirmModal}>
            <p className="text-[16px] text-grey-600 pb-[24px]">سيتم خصم مبلغ <span className="font-bold">{businessPackage?.packageRestrictions?.additionalUnitCost} ريال</span> مقابل إضافة وحدة إضافية, هل انت متأكد من اكمال الطلب؟</p>
            <div className="text-end">
                <NormalButton label={'تأكيد الطلب'} onClick={handleClickConfirmExtraUnitAction} color={'!bg-grey-800 !w-[228px] !text-center'} />
                <NormalButton label={'إلغاء'} onClick={handleCloseConfirmModal} color={'!bg-white !w-[228px] !text-grey-600 !border-[1px] !border-grey-600 !rounded-[8px] !ms-[24px]'} />
            </div>
        </ModalContainer>}
        <Toast toast={toast} setToast={setToast} />
        <Loading showLoading={showLoading} />
    </>
  );
};

export default UnitAddPage;
